export default __webpack_public_path__ + "static/media/pw.0d5193b8.jpg";